import { render, staticRenderFns } from "./AwaitingLots.vue?vue&type=template&id=156574a6&"
import script from "./AwaitingLots.vue?vue&type=script&lang=js&"
export * from "./AwaitingLots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports